import { PaymentMethod } from "./Types";

export const LOADING_PAYMENT_METHODS = "LOADING_PAYMENT_METHODS";
export const SET_PAYMENT_METHODS = "SET_PAYMENT_METHODS";

export const loadingPaymentMethods = () => ({ type: LOADING_PAYMENT_METHODS });
export const setPaymentMethods = (paymentMethods: PaymentMethod[]) => ({
    type: SET_PAYMENT_METHODS,
    paymentMethods,
  });